import { render, staticRenderFns } from "./SignupCard.vue?vue&type=template&id=d2e282e8&"
import script from "./SignupCard.vue?vue&type=script&lang=ts&"
export * from "./SignupCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports